import { useMemo } from 'react'

export const usePairIconSizes = ({
  size,
  outlined,
}: {
  size: number
  outlined: boolean
}) => {
  const padding = useMemo(() => {
    if (!outlined) {
      return 0
    }

    if (size > 49) {
      return 2
    }
    if (size > 19) {
      return 1
    }
    return 0
  }, [outlined, size])

  const premiumFallbackSize = padding ? size - (padding + 1) * 2 : size

  const { outerRadius, innerRadius, auxIconOffset, auxIconSize } =
    useMemo(() => {
      if (size > 63) {
        return {
          outerRadius: 10,
          innerRadius: 8,
          auxIconOffset: -3,
          auxIconSize: 18,
        }
      }
      if (size > 49) {
        return {
          outerRadius: 8,
          innerRadius: 6,
          auxIconOffset: -3,
          auxIconSize: 16,
        }
      }
      if (size > 39) {
        return {
          outerRadius: 8,
          innerRadius: 6,
          auxIconOffset: -3,
          auxIconSize: 14,
        }
      }
      if (size > 29) {
        return {
          outerRadius: 6,
          innerRadius: 4,
          auxIconOffset: -2,
          auxIconSize: 10,
        }
      }
      return {
        outerRadius: 4,
        innerRadius: 3,
        auxIconOffset: -1,
        auxIconSize: 8,
      }
    }, [size])

  return {
    outerRadius,
    innerRadius,
    auxIconSize,
    auxIconOffset,
    padding,
    premiumFallbackSize,
    fallbackFontSize: Math.floor(size / 3.4),
  }
}
